<h1>ダイアログ呼び出し再現</h1>
<div lass="tw-flex tw-flex-row">
    <button disabled type="button" mat-raised-button color="primary" class="btn tw-flex tw-flex-row tw-flex-wrap"
        style="margin-left: 10px; margin-top: 10px;" (click)="onClickShishinBtn()">
        指針入力(SGKE340D_供給停止結果登録画面)
    </button>
    <br>
    <button type="button" mat-raised-button color="primary" class="btn" style="margin-left: 10px; margin-top: 5px;"
        (click)="onClickShishinBtn()">
        指針入力(SGKE360D_供給再開結果登録画面)
    </button>
    <br>
    <h2>ダイアログ戻り値</h2>
    <div style="margin-left: 10px" id="target-container"></div>
</div>